import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './Store/store';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ResultComponent from './Comp/ResultComponent/ResultComponent';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <React.StrictMode>
        <Routes>
          <Route
            path="/invalid-document"
            element={<ResultComponent title="Document Verification Failed, Invalid Document." />}
          />
          <Route
            path="/unauthorized"
            element={<ResultComponent title="Security Veification Failed , Unauthorized Access." subTitle="If you believe you should have access to this document please logout and login again. Incase the issues persists please contact the document owner." />}
          />
          <Route path="/:id" element={<App />} />
        </Routes>
      </React.StrictMode>
    </BrowserRouter>
  </Provider>
);

